import React, { useEffect, useState } from "react";
import { Modal, Table, Button, Flex, Skeleton } from "antd";
import { ReactComponent as Download } from "../../../assets/Icons/downloadIcon.svg";
import "./PortfolioUploadedFiles.scss";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchPortfolioFiles } from "../../../store/portfolioSlice";
import { downloadAllFiles } from "../../../assets/api/portfolio";

const PortfolioUploadedFiles = ({ isVisible, onClose, selectedPortfolio }) => {
  const dispatch = useDispatch();
  const { uploaded_files, uploaded_files_loading } = useSelector(state => state.portfolio);
  const { token } = useSelector(state => state.auth);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: "File Name",
      dataIndex: "file_name",
      key: "fileName",
      render: (text) => uploaded_files_loading ? <Skeleton.Input size="small" active /> : text || 'NA'
    },
    {
      title: "Uploaded On",
      dataIndex: "uploaded_on",
      key: "uploaded_on",
      render: (text) => uploaded_files_loading ? <Skeleton.Input size="small" active /> : text || 'NA'
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        uploaded_files_loading ? <Skeleton.Input size="small" active /> :
          <Button
            type="text"
            icon={<Download />}
            onClick={() => handleDownload(record.file_url)}
          />
      ),
    },
  ];


  const handleDownload = (file_url) => {
    const link = document.createElement("a");
    link.href = file_url;
    link.setAttribute("download", "file");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    dispatch(fetchPortfolioFiles({ portfolio_id: selectedPortfolio?.id }))
  }, [dispatch])

  const handleDownloadAllFiles = async () => {
    try {
       setLoading(true);
      const res = await downloadAllFiles(token, selectedPortfolio?.id);
      if (res?.status === 200) {
        let url = res?.data?.data?.download_url;
        handleDownload(url);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false)
    }
  }
  return (
    <Modal
      className="uploadModalContainer"
      title="Uploaded Files"
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      width={631}
      height={312}
    >
      <Flex className="downloadBtnWrapper">
        <Button className="downloadBtn" loading={loading} onClick={handleDownloadAllFiles}>
          Download All <Download />
        </Button>
      </Flex>
      <ReusableTable
        columns={columns}
        dataSource={uploaded_files_loading ? Array(4).fill(0) : uploaded_files?.files}
        rowKey="key"
        bordered
        totalItems={uploaded_files?.total_files}
      />
    </Modal>
  );
};

export default PortfolioUploadedFiles;
